module.exports = __webpack_public_path__ + "static/media/3-military.29d0cbbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-military.svg
// module id = 746
// module chunks = 3